export default __webpack_public_path__ + "static/media/cabana_cheveron_down.19cd2855.svg";